import axios from 'axios';

export default axios.create({
  // TODO: Use environment variable for baseURL
  baseURL: process.env.REACT_APP_CUPPYBET_API_BASE_URL  // "http://localhost:3300",
})
